import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Join class names and resolve Tailwind conflicts so a caller's `className`
 * overrides a primitive's defaults (`cn('px-3', 'px-4')` → `'px-4'`).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
